import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import style from "../../assets/css/components/Form/Form.module.css";
import Button from "../Button/Button";
import Input from "../Input/Input";
import InputSelect from "../Input/InputSelect";

import { AddGoalInitialState, AddGoalValidationSchema } from "../../utils/goal";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { socket } from "../../config/socket";
const MySwal = withReactContent(Swal);

function FormGoal({
  idMatch,
  typeMatch,
  statusMatch,
  teams,
  playersLocal,
  playersVisit,
  autoGoal,
}) {

  console.log(idMatch);
  console.log(typeMatch);
  console.log(statusMatch);

  const handleSubmit = async (values) => {
    // console.log(values);
    const { team, time, player, description } = values;
    let playersTeam = [];
    let title = "";
    let type = 1;

    if (team === "1") {
      playersTeam = autoGoal ? playersVisit : playersLocal;
    } else {
      playersTeam = autoGoal ? playersLocal : playersVisit;
    }

    const objIndex = playersTeam.findIndex((obj) => obj.value === player);
    title = playersTeam[objIndex].label;

    if (statusMatch !== "de") {
      socket.emit(
        "updateGoal",
        { idMatch, team, player, autoGoal, typeMatch },
        (match) => {
          MySwal.fire("goool");
          // console.log(match);
        }
      );
    }

    socket.emit(
      "addStory",
      { idMatch, team, time, title, description, type },
      (story) => {
        MySwal.fire("story agregado");
        // console.log(story);
      }
    );
  };

  return (
    <Formik
      initialValues={AddGoalInitialState}
      validationSchema={AddGoalValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.threeColumn)}>
            <InputSelect
              error={touched.team && errors.team}
              name="team"
              title={autoGoal ? "Gol para" : "Gol"}
              options={teams}
              onChange={(selectedOption) => {
                handleChange("team")(selectedOption.value);
              }}
            />
            <Input name="time" title="Minuto de juego" type="number" />
            <InputSelect
              error={touched.player && errors.player}
              name="player"
              title="Jugador"
              options={
                values.team === "1"
                  ? autoGoal
                    ? playersVisit
                    : playersLocal
                  : values.team === "2"
                  ? autoGoal
                    ? playersLocal
                    : playersVisit
                  : []
              }
              onChange={(selectedOption) => {
                handleChange("player")(selectedOption.value);
              }}
            />
            <div className={style.inputLong}>
              <Input name="description" title="Descripción" />
            </div>
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormGoal;
